'use client'

/* eslint-disable react/no-danger */
import Image from 'next/image'
import { type AutoWidgetVariant } from 'src/enums/AutoProduct'
import { ButtonType } from 'src/enums/ButtonType'
import { BannerIconPosition } from 'src/enums/NewFlowBanner'
import { Button } from '../AutoWidgetButton/button'

interface Icon {
  src?: string
  alt?: string
  position?: BannerIconPosition
  width: number
  height: number
}

export interface NewFlowBannerProps {
  title: string
  subTitle: string
  icon: Icon
  ctaText: string
  redirectionUrl: string
  InsuretrackEventName?: string
  InsureSegmentTrackProps?: object
  widgetVariant?: AutoWidgetVariant
  isBottomFloater?: boolean
  isOldLayout?: boolean
  isSeoPurpleVariant?: boolean
  combinedStyles?: any
}

const NewFlowBanner = ({
  title,
  subTitle,
  icon,
  ctaText,
  redirectionUrl,
  InsuretrackEventName,
  InsureSegmentTrackProps,
  widgetVariant,
  isBottomFloater,
  isSeoPurpleVariant = false,
  isOldLayout = false,
  combinedStyles,
}: NewFlowBannerProps) => {
  const onCtaClick = () => {
    window.location.href = redirectionUrl
  }

  return (
    <>
      {combinedStyles && (
        <div
          id="auto-widget-flow-banner-styles"
          style={{ display: 'none' }}
          dangerouslySetInnerHTML={{ __html: combinedStyles['newFlowBanner.module.scss'] }}
        />
      )}
      <div
        className={`newFlowRootContainer ${
          isOldLayout && !isBottomFloater ? 'newSemDesktopVariant' : 'newSeoVariant'
        } ${isSeoPurpleVariant && 'newSeoPurpleVariant'} ${isBottomFloater ? 'bottomFloater' : ''}`}>
        <div className={`bannerDetails ${icon?.position === BannerIconPosition.right && 'rightImageVariant'}`}>
          <div className="leftContainer">
            {icon?.position === BannerIconPosition.left && icon?.src ? (
              <Image className="icon" src={icon?.src} alt={icon?.alt || ''} width={icon?.width} height={icon?.height} />
            ) : null}
            <div className="textContainer">
              <div className={`title ${isOldLayout && 'flipFont'}`}>{title}</div>
              <div className={`subTitle ${isOldLayout && 'flipFont'}`}>{subTitle}</div>
            </div>
          </div>
          {icon?.position === BannerIconPosition.right && icon?.src ? (
            <Image className="icon" src={icon?.src} alt={icon?.alt || ''} width={icon?.width} height={icon?.height} />
          ) : null}

          {isOldLayout && !isBottomFloater ? (
            <div className="newFlowshowOnlyWeb">
              <Button
                onClick={onCtaClick}
                ctaText={ctaText}
                type={ButtonType.White}
                segmentEventName={InsuretrackEventName}
                segmentEventProps={InsureSegmentTrackProps}
              />
            </div>
          ) : null}
        </div>
        <div className="newFlowShowOnlyMweb">
          <Button
            onClick={onCtaClick}
            ctaText={ctaText}
            type={ButtonType.White}
            segmentEventName={InsuretrackEventName}
            segmentEventProps={InsureSegmentTrackProps}
          />
        </div>
      </div>
    </>
  )
}

export default NewFlowBanner
